'use server';

import request from '../../../../api/request';
import { actionKitImpFunction } from '../../../../components/ozmoit/common/action-kit-imp';

export const getAdmissionProcessAction = actionKitImpFunction(
  async ({ id }: { id: number }) => {
    const [processResponse, availableOffersResponse] = await Promise.all([
      request<any>(
        `/maintainers-portal/academic-offer/admission-processes/${id}`,
        {
          method: 'GET',
        },
      ),
      request<any>(
        `/maintainers-portal/academic-offer/admission-processes/${id}/available-offers`,
        {
          method: 'GET',
        },
      ),
    ]);

    if (processResponse.error) {
      throw new Error(
        processResponse.error.error.message ||
          'Error fetching admission process',
      );
    }

    if (availableOffersResponse.error) {
      throw new Error(
        availableOffersResponse.error.error.message ||
          'Error fetching available offers',
      );
    }

    return {
      process: processResponse.data,
      availableOffers: availableOffersResponse.data,
    };
  },
);

export const createAdmissionProcessAction = actionKitImpFunction(
  async ({ data }: { data: any }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes`,
      {
        method: 'POST',
        data,
      },
    );

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error creating admission process',
      );
    }

    return response.data;
  },
);

export const updateAdmissionProcessAction = actionKitImpFunction(
  async ({ id, data }: { id: number; data: any }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes/${id}`,
      {
        method: 'PUT',
        data,
      },
    );

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error updating admission process',
      );
    }

    return response.data;
  },
);

export const getAdmissionProcessFormAction = actionKitImpFunction(async () => {
  const response = await request<any>(
    `/maintainers-portal/academic-offer/admission-processes/form`,
    {
      method: 'GET',
    },
  );

  if (response.error) {
    throw new Error(
      response.error.error.message || 'Error fetching admission process form',
    );
  }

  return response.data;
});

export const getAvailableOffersAction = actionKitImpFunction(
  async ({ id }: { id: number }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes/${id}/available-offers`,
      {
        method: 'GET',
      },
    );

    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error fetching available offers',
      );
    }

    return response.data;
  },
);

export const addOfferAction = actionKitImpFunction(
  async ({ id, data }: { id: number; data: any }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes/${id}/offers`,
      {
        method: 'POST',
        data,
      },
    );

    if (response.error) {
      throw new Error(response.error.error.message || 'Error adding offer');
    }

    return response.data;
  },
);

export const deleteOfferAction = actionKitImpFunction(
  async ({ admissionId }: { admissionId: number }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes/admission/${admissionId}`,
      {
        method: 'DELETE',
      },
    );

    if (response.error) {
      throw new Error(response.error.error.message || 'Error deleting offer');
    }

    return response.data;
  },
);

export const bulkPreviewAction = actionKitImpFunction(
  async ({ id, data }: { id: number; data: any }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes/${id}/admissions/bulk-preview`,
      { method: 'POST', data },
    );
    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error previewing bulk admissions',
      );
    }
    return response.data;
  },
);

export const bulkSaveAction = actionKitImpFunction(
  async ({ id, data }: { id: number; data: any }) => {
    const response = await request<any>(
      `/maintainers-portal/academic-offer/admission-processes/${id}/admissions/bulk`,
      { method: 'PUT', data },
    );
    if (response.error) {
      throw new Error(
        response.error.error.message || 'Error saving bulk admissions',
      );
    }
    return response.data;
  },
);
